import * as React from "react";

const SvgRainSun = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainSun_svg__a">
        <path d="M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainSun_svg__b">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainSun_svg__c">
        <path d="M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainSun_svg__d">
        <path d="m895.908 219.964-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainSun_svg__e">
        <path d="m909.52 219.964-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainSun_svg__f">
        <path d="m924.132 219.964-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#RainSun_svg__a)"
      style={{
        fill: "#febf25",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
    >
      <g
        style={{
          fill: "#febf25",
          fillOpacity: 1,
        }}
      >
        <path
          d="M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
          style={{
            fill: "#febf25",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainSun_svg__b)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.889 0 10.664 4.774 10.664 10.664S5.889 21.328 0 21.328c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.005-.253.005-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(928.4 228.31)"
        />
      </g>
    </g>
    <g
      clipPath="url(#RainSun_svg__c)"
      style={{
        fill: "#d7eaf9",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
    >
      <g
        style={{
          fill: "#d7eaf9",
          fillOpacity: 1,
        }}
      >
        <path
          d="M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
          style={{
            fill: "#d7eaf9",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainSun_svg__d)"
      style={{
        fill: "#00b4f0",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
    >
      <g
        style={{
          fill: "#00b4f0",
          fillOpacity: 1,
        }}
      >
        <path
          d="m895.908 219.964-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
          style={{
            fill: "#00b4f0",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainSun_svg__e)"
      style={{
        fill: "#00b3f0",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
    >
      <g
        style={{
          fill: "#00b3f0",
          fillOpacity: 1,
        }}
      >
        <path
          d="m909.52 219.964-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
          style={{
            fill: "#00b3f0",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainSun_svg__f)"
      style={{
        fill: "#00b4f0",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
    >
      <g
        style={{
          fill: "#00b4f0",
          fillOpacity: 1,
        }}
      >
        <path
          d="m924.132 219.964-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
          style={{
            fill: "#00b4f0",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        stroke: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 -384 1257.85)"
      d="M288-943.388h72v72h-72z"
    />
  </svg>
);

export default SvgRainSun;
